// extracted by css-extract-rspack-plugin
export default {"root":"root-pTvF8p","name":"name-A8SlUG","logo":"logo-BwlvcC"};